import '../css/app.less';

import { initRoutes } from '@eidellev/adonis-stardust/client';
initRoutes();

// import initTippy from './modules/init-tippy';
import './modules/age-gate';
import './modules/lazysizes';
import './modules/nav';
import './modules/smooth-scrolling';
import './modules/modal';
import './modules/cookiebot';
import './modules/set-css-variables';
import './modules/ie-banner';
import './modules/scrollmagic';
import './modules/forms';

import './modules/accordion';

// document.addEventListener('DOMContentLoaded', () => {
//   console.info('Hello World');

//   initTippy();
// });

// setTimeout(function() {
// 	// eslint-disable
// 	grecaptcha.render(
// 		document.querySelector('#g-recaptcha-2')
// 	);
// }, 1000);

